import { render, staticRenderFns } from "./BadNumberReason.container.vue?vue&type=template&id=ffd48968&scoped=true&"
import script from "./BadNumberReason.container.vue?vue&type=script&lang=js&"
export * from "./BadNumberReason.container.vue?vue&type=script&lang=js&"
import style0 from "./BadNumberReason.container.vue?vue&type=style&index=0&id=ffd48968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd48968",
  null
  
)

export default component.exports